import styled from "styled-components";
import { Select } from "antd";
import { AutoComplete } from "antd";
import { createGlobalStyle } from "styled-components";
import { globalColor } from "../../../components/utils/RepeatFunctions/Schedule";

export const Div = styled.div`
  display: ${(p) => p.display && p.display};
  height: ${(p) => p.height && p.height};
  width: ${(p) => p.width && p.width};
  margin: ${(p) => p.margin && p.margin};
  padding: ${(p) => p.padding && p.padding};
  background-color: ${(p) => p.backgroundColor && p.backgroundColor};
  margin-top: ${(p) => p.marginTop && p.marginTop};
  margin-bottom: ${(p) => p.marginBottom && p.marginBottom};
  margin-left: ${(p) => p.marginLeft && p.marginLeft};
  margin-right: ${(p) => p.marginRight && p.marginRight};
  flex-wrap: ${(p) => p.flexWrap && p.flexWrap};
  position: ${(p) => p.position && p.position};
`;
export const Span = styled.span`
  margin: ${(p) => p.margin && p.margin};
  margin-bottom: ${(p) => p.marginBottom && p.marginBottom};
  margin-left: ${(p) => p.marginLeft && p.marginLeft};
  font-size: ${(p) => p.fontSize && p.fontSize};
  color: ${(p) => p.color && p.color};
  height: ${(p) => p.height && p.height};
  width: ${(p) => p.width && p.width};
  font-weight: ${(p) => p.fontWeight && p.fontWeight};
  color: ${(p) => p.color && p.color};
  font-family: ${(p) => p.fontFamily && p.fontFamily};
  line-height: ${(p) => p.lineHeight && p.lineHeight};
  cursor: ${(p) => p.cursor && p.cursor};
`;
export const Button = styled.button`
  background: ${(p) => p.background && p.background};
  border: ${(p) => p.border && p.border};
  height: ${(p) => p.height && p.height};
  width: ${(p) => p.width && p.width};
  color: ${(p) => p.color && p.color};
  margin-top: ${(p) => p.marginTop && p.marginTop};
  margin-left: ${(p) => p.marginLeft && p.marginLeft};
  margin-right: ${(p) => p.marginRight && p.marginRight};
  margin-bottom: ${(p) => p.marginBottom && p.marginBottom};
  border-radius: ${(p) => p.borderRadius && p.borderRadius};
  position: ${(p) => p.position && p.position};
  padding: ${(p) => p.padding && p.padding};
  ${(p) =>
    p.lock &&
    `svg {
     margin-top:-3px;
     margin-right:1px;
    }
    `}

  &.save_active:active {
    background-color: rgba(44, 123, 229, 0.75);
  }
  &.save_active:disabled {
    background-color: rgba(44, 123, 229, 0.5);
    cursor: not-allowed;
  }
  &.close_active:active {
    background-color: rgba(44, 123, 229, 0.1);
  }
  &.close_active:disabled {
    color: rgba(44, 123, 229, 0.5);
    background-color: #fff;
    cursor: not-allowed;
  }
  &:hover {
    background-color: ${(p) => p.hoverBackColor && p.hoverBackColor};
  }
  &:active {
    background-color: ${(p) => p.ActiveBackColor && p.ActiveBackColor};
    border: ${(p) => p.border && p.border};
  }
`;
export const SelectAnt = styled(Select)`
  width: ${(p) => p.width && p.width};
  margin-right: ${(p) => p.marginright && p.marginright};
  font-family: ${(p) => p.fontFamily && p.fontFamily};
  color: ${(p) => p.color && p.color};
  position: ${(p) => p.position && p.position};
  margin-top: ${(p) => p.margintop && p.margintop};

  &.ant-select-single .ant-select-selector :hover {
    border-color: #d9d9d9 !important;
  }
  &.ant-select-single .ant-select-selector {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
    border-radius: 4px !important;
    height: 36px;
    display: flex;
    align-items: center;
    padding: 0 30px 0 12px !important; /* arrow ku space */
  }
  &.ant-select-single .ant-select-arrow {
    right: 10px !important;
    margin-top: 2px !important;
    top: 50% !important;
    transform: translateY(-50%) !important; /* perfect vertical center */
    display: flex;
    align-items: center;
  }

  &.ant-select-multiple .ant-select-arrow {
    top: 0% !important;
    margin-top: 10px !important;
  }

  &.ant-select-single .ant-select-selector .ant-select-selection-item,
  &.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    font-weight: 400 !important; /* normal font */
    font-size: 14px !important; /* same as other inputs */
    line-height: normal !important; /* natural centering */
    display: flex;
    align-items: center;
    color: #718096 !important;
  }

  &.ant-select-multiple .ant-select-selection-item {
    background-color: #ebf3ff !important;
    color: ${globalColor} !important;
  }

  &.ant-select-multiple .ant-select-selection-item-content {
    font-size: 12px !important;
    font-weight: 500;
  }

  &.ant-select-multiple .ant-select-selection-item-remove {
    color: ${globalColor} !important;
    font-weight: 500;
    font-size: 8px;
  }

  &.ant-select-multiple .ant-select-selector {
    border-radius: 4px !important;
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }

  &.ant-select-multiple .ant-select-selector:hover {
    border-color: #d9d9d9 !important;
  }

  &.ant-select-multiple .ant-select-selection-placeholder {
    color: #718096 !important;
  }
`;

export const Imagecalendar = styled.img`
  position: absolute;
  top: ${(p) => (p.top ? p.top : "20px")};
  right: ${(p) => (p.right ? p.right : "163px")};
  width: 16px;
  height: 16px;
  object-fit: contain;
  cursor: pointer;
`;
export const AutoCompleteAnt = styled(AutoComplete)`
  width: 100%;

  .ant-select-selector {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
    border-radius: 4px !important;
    height: 36px !important;
    display: flex;
    align-items: center;
    padding-left: 34px !important;
  }

  .ant-select-selection-search-input {
    height: 34px !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    padding-left: 0 !important;
  }

  .ant-select-selection-placeholder {
    color: #718096 !important;
    font-family: ${(p) => p.fontFamily && p.fontFamily};
  }

  .ant-select-selection-item {
    font-family: ${(p) => p.fontFamily && p.fontFamily};
    color: #718096 !important;
  }
  &.ant-select-focused .ant-select-selector {
    border-color: #2c7be5 !important;
    box-shadow: none !important;
  }

  &:hover .ant-select-selector {
    border-color: #d9d9d9 !important;
  }
`;
export const AutoCompleteIconStyle = createGlobalStyle`
  .autocomplete-with-icon {
    position: relative;
  }

  .left-search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #a0aec0;
    font-size: 16px;
    z-index: 10;
    pointer-events: none;
  }
`;

export const DatePickerStyleFix = createGlobalStyle`
  .ant-picker {
    height: 36px !important;
    border-radius: 4px !important;
    border-color: #d9d9d9 !important;
    display: flex !important;
    align-items: center !important;
    margin-top: 0px !important;
  }

  .ant-picker-input {
  display: flex !important;
  align-items: center !important;   /* icon + text same vertical line */
}

  /* Calendar icon ah left side kondu vara */
  .ant-picker-suffix {
    order: -1 !important;
    margin-top: 2px !important;
    margin-right: 6px !important;
    margin-left: 0 !important;
    align-items: center;
    display: flex;
  }

  .ant-picker-input > input {
    height: 34px !important;
    padding-left: 4px !important;
    line-height: 34px !important;
  }
    .ant-picker-dropdown table,
  .ant-picker-dropdown th,
  .ant-picker-dropdown td {
    border: none !important;
    background: transparent !important;
  }

  /* Protect the days of the week header from your global thead rules */
  .ant-picker-dropdown thead tr th {
    background: transparent !important;
    border-bottom: none !important;
  }
`;
export const PracticeTableStyles = createGlobalStyle`
  /* Full table outer box */
  .practice_dashboard_tablealt {
    border: 1.5px solid #C8CDD4;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
  }

  /* Group header (Appointment Details, Notes, Services, Billing) */
  .head_report {
    font-weight: 500 !important;      /* normal text, not bold */
    border-bottom: 1.5px solid #C8CDD4 !important;
  }

  .head_report1 {
    border-right: 1.5px solid #C8CDD4 !important;
  }

  /* Second header row */
  thead tr:nth-child(2) th {
    font-weight: 500 !important;
    background: #F5F8FB !important;
    border-bottom: 1.5px solid #C8CDD4 !important;
  }

  /* Table borders */
  table {
    border-collapse: collapse !important;
  }

  // th, td {
  //   border-right: 1px solid #D1D6DE !important;
  //   border-bottom: 1px solid #D1D6DE !important;
  // }

  tr:last-child td {
    border-bottom: none !important;
  }

  th:last-child,
  td:last-child {
    border-right: none !important;
  }

  /* Body text normal (not bold) */
  tbody td {
    font-weight: 400 !important;
    color: #2E2E2E;
  }

  /* Appointment status normal */
  .apptdos span {
    font-weight: 400 !important;
  }

  /* Hover row */
  tbody tr:hover {
    background: #F9FBFD;
  }

  /* Paid badge style */
  .paid-status {
    background: #DFF5E1;
    color: #1E7E34;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
  }
   /* 1. Strip the background from the outer wrapper */
  .practice-payment-container .paid-status {
    background: transparent !important;
    padding: 0 !important;
  }

  /* 2. Fix the inner spans to behave like proper badges */
  .practice-payment-container .paid, 
  .practice-payment-container .ivoicetablePaid, 
  .practice-payment-container .ivoicetableUnPaid, 
  .practice-payment-container .ivoicetablePartialPaid {
    display: inline-block !important; /* Forces it to respect padding */
    padding: 4px 12px !important;
    border-radius: 12px !important; /* Perfect pill shape */
    font-size: 13px !important;
    font-weight: 500 !important;
    white-space: nowrap !important; /* Prevents text from breaking */
    position: static !important; /* Overrides rogue global absolute positioning */
    line-height: normal !important;
  }

  /* 3. Re-apply the green colors cleanly */
  .practice-payment-container .ivoicetablePaid {
    background: #DFF5E1 !important;
    color: #1E7E34 !important;
  }
`;
export const SelectDropdownStyleFix = createGlobalStyle`
  /* Dropdown option text normal (not bold) */
  .ant-select-dropdown .ant-select-item-option-content {
    font-weight: 400 !important;
    font-size: 14px !important;
    color: #2E2E2E !important;
  }

  /* Selected option also not bold */
  .ant-select-dropdown .ant-select-item-option-selected 
  .ant-select-item-option-content {
    font-weight: 400 !important;
  }

  /* Hover background soft */
  .ant-select-dropdown .ant-select-item-option-active {
    background: #F5F8FB !important;
  }
`;
